import React from "react";
import { translate } from "@td/shared_utils";
import { statusCodes } from "../constants";
import { FieldLabel, FieldValue } from "../components";
import { useInitialState } from "../contexts/initial-state-context";

const CurrentStatus = React.memo(() => {
  const { consultation } = useInitialState();

  return (
    <FieldLabel>
      {translate(null, "pre_intake.fields.status", "label")}

      <FieldValue>
        {translate(
          null,
          "teladoc_constants_gem.consult_events.status_reasons_localized",
          consultation.preIntakeStatusCode || statusCodes.PRE_INTAKE_NOT_STARTED
        )}
      </FieldValue>
    </FieldLabel>
  );
});

CurrentStatus.displayName = "CurrentStatus";

export default CurrentStatus;
